var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"dense":_vm.dense,"type":"text","option":{ currency: 'IDR' },"disabled":_vm.disabled,"label":_vm.label,"required":""},on:{"input":_vm.onInput},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})
}
var staticRenderFns = []

export { render, staticRenderFns }